import './Styles.scss'

const init = () => {
    if (window.scrollY > 100) {
        window.removeEventListener('scroll', init)

        let scriptTag = document.createElement('script')
        scriptTag.setAttribute('src', 'https://pocitadlolibise.seznam.cz/pocitadlolibise.js')
        scriptTag.setAttribute('defer', 'defer')
        document.body.appendChild(scriptTag)
    }
}

document.addEventListener('DOMContentLoaded', function () {
    const likeButton = document.getElementsByTagName('seznam-pocitadlolibise')

    if (likeButton.length > 0) {
        // Lazy load after 100px scroll
        window.addEventListener('scroll', init)

        init()
    }
})